var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinishIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.94102 2.4125C2.6874 2.4125 2.44418 2.51325 2.26484 2.69258C2.08551 2.87191 1.98477 3.11514 1.98477 3.36875V16.7563C1.98477 17.0099 2.08551 17.2531 2.26484 17.4324C2.44418 17.6118 2.6874 17.7125 2.94102 17.7125H6.76602C7.29414 17.7125 7.72227 18.1406 7.72227 18.6688C7.72227 19.1969 7.29414 19.625 6.76602 19.625H2.94102C2.18018 19.625 1.4505 19.3228 0.912503 18.7848C0.374508 18.2468 0.0722656 17.5171 0.0722656 16.7563V3.36875C0.0722656 2.60791 0.374508 1.87823 0.912503 1.34024C1.4505 0.802242 2.18018 0.5 2.94102 0.5H6.76602C7.29414 0.5 7.72227 0.928128 7.72227 1.45625C7.72227 1.98437 7.29414 2.4125 6.76602 2.4125H2.94102ZM12.7836 4.60509C13.157 4.23165 13.7625 4.23165 14.136 4.60509L18.9142 9.38338C18.9244 9.39341 18.9343 9.40367 18.9439 9.41414C19.0188 9.49516 19.077 9.58599 19.1187 9.68227C19.1693 9.7988 19.1973 9.92739 19.1973 10.0625C19.1973 10.198 19.1691 10.3269 19.1183 10.4436C19.0771 10.5387 19.0196 10.6284 18.946 10.7086C18.9356 10.7199 18.925 10.731 18.914 10.7418L14.136 15.5199C13.7625 15.8934 13.157 15.8934 12.7836 15.5199C12.4102 15.1465 12.4102 14.541 12.7836 14.1676L15.9324 11.0188H6.76604C6.23792 11.0188 5.80979 10.5906 5.80979 10.0625C5.80979 9.53438 6.23792 9.10626 6.76604 9.10626H15.9324L12.7836 5.95743C12.4102 5.58399 12.4102 4.97852 12.7836 4.60509Z",
    fill: "#F5F9FF",
    fillOpacity: 0.95
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinishIcon);
export default __webpack_public_path__ + "static/media/finish-icon.9098470d2670d664eeb442a4ff6a7c40.svg";
export { ForwardRef as ReactComponent };